var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grammar"},[(_vm.component)?_c(_vm.component,{tag:"component"}):[_c('v-skeleton-loader',{attrs:{"type":"card"}}),_c('v-skeleton-loader',{attrs:{"type":"article"}}),_c('v-skeleton-loader',{attrs:{"type":"card"}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }